import React from 'react'
import { Card, Container, Tab, Tabs } from 'react-bootstrap';
import { AllStudents, PaidStudents } from './Tables';

export default function AllStudentIndex() {

    return (
        <>
            <Container className="pt-4">
                <Card className="mt-4">
                    <Card.Title className='m-2'>All Students</Card.Title>
                    <Card.Body>

                        <Tabs
                            defaultActiveKey="all"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab
                                eventKey="all"
                                title={
                                    <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>All Students</div>
                                }
                            >
                                <AllStudents />
                            </Tab>
                            <Tab
                                eventKey="paid"
                                title={
                                    <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                                        Paid
                                    </div>
                                }
                            >
                                <PaidStudents />
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
};